import React, { FC, useCallback } from 'react';
import { Button, Col, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import { CompositeCriterionOptions, CompositeOperation } from '../../../../../shared/orders/raffle';
import { Breadcrumb } from '../../../../components';
import { MaterialIconText } from '../../../../components/MaterialIconText';
import { useTranslation } from '../../../../translations';
import { emptyFallback, useInputState } from '../../../../utils';
import { RaffleConfiguratorProps } from '../utils';

export const MathOperation: FC<RaffleConfiguratorProps<CompositeCriterionOptions>> = ({
  defaultOptions,
  displayName,
  onBack,
  onCancel,
  onConfigure,
}) => {
  const { ts } = useTranslation();
  const [operator, setOperator] = useInputState<CompositeOperation>(
    defaultOptions?.operator ?? 'add',
  );

  const onFinish = useCallback(() => {
    onConfigure({ name: 'composite', options: { operator } });
  }, [onConfigure, operator]);

  return (
    <>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <Breadcrumb
              items={[
                { text: `${ts('common.display_name')}: ${emptyFallback(displayName, 'None')}` },
                { text: `${ts('type')}: Composite Operation` },
              ]}
            />
            <MaterialIconText name="keyboard_backspace" onClick={onBack}>
              {ts('common.go_back')}
            </MaterialIconText>
            <hr />
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="operation">{ts('operation')}</Label>
              <Input
                defaultValue={operator}
                id="operation"
                name="operation"
                onChange={setOperator}
                required
                type="select"
              >
                <option value="add">{ts('common.add')}</option>
                <option value="multiply">{ts('multiply')}</option>
                <option value="max">{ts('max')}</option>
                <option value="min">{ts('min')}</option>
                <option value="pow">{ts('pow')}</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button className="editor-finish-btn" color="primary" onClick={onFinish}>
          {ts('common.finish')}
        </Button>
        <Button className="editor-cancel-btn" color="secondary" onClick={onCancel} outline>
          {ts('common.cancel')}
        </Button>
      </ModalFooter>
    </>
  );
};
